import { Kitchen } from '../kitchen.class';
import type { KitchenTrimProfile } from '../types';

/**
 * Derives the kitchen-wide corner trim profile from every island's PanelTrims
 * @param kitchen the kitchen to inspect
 * @returns 'mixed' when the design holds both profiles; 'standard' is the default, including a design carrying no trims at all
 */
export const getTrimProfileCfn = (kitchen: Kitchen): KitchenTrimProfile => {
	const panelTrims = kitchen.design.islands.children.flatMap((island) => island.panelTrims?.children ?? []);
	const flatCount = panelTrims.filter((panelTrim) => panelTrim.isFlat).length;

	if (flatCount === 0) return 'standard';

	return flatCount === panelTrims.length ? 'flat' : 'mixed';
};
